import BookmarkReducer from './bookmark_reducer';
import ReleaseReducer from './release_reducer';
import ViewOptionsReducer from './view_options_reducer';

export default function (state, action) {
  let newState = ReleaseReducer(state, action);
  newState = ViewOptionsReducer(newState, action);
  newState = BookmarkReducer(newState, action);

  return newState;
}
